import PesananService from '@/services/pesanan'
import ProductsService from '@/services/products'
import UserService from '@/services/user'
import TransactionService from '@/services/transaction'
import { forEach,isEmpty } from "lodash"

export default {
	namespaced: true,
	state: {
		listOrder: [],
		totalHargaPesanan: 0,
		numberOfList: 0,
		dialogOrder: false,
		dialogPayment: false,
		idDialogOrder: 0,
        dataDetails: { 
			"items": []
		  },
		dataUser: {},
		paymentItems: null,
		paid: 0,
		jumlahPayment: 0,
		dialogLogin: false,
		dialogRegis: false,
		selectedCustomer: null,
		userFound: false,
		inputSearch: null
	},

	getters: {
		async getItems({ commit, state, getters, dispatch }) {
			try {
				let response = await ProductsService.getItems()
				return response
			} catch (e) {
				console.log(e)
			}
		}
	},

	actions: {
		async getPesanans({ commit, state, getters, dispatch }) {
			try {
				let response = await PesananService.getPesanan()
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async updatePesanan({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PesananService.updatePesanan(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async updateStatusPesanan({ commit, state, getters, dispatch }, payload) {
			try {
				const response = await PesananService.updateStatusPesanan(payload.id, {
					...payload
				})
				return response
			} catch (e) {
				console.log(e);
			}
		},
		async getPesananById({ commit, state, getters, dispatch }, id) {
			try {
				// console.log('id', id)
				let response = await PesananService.getPesananById(id)
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async deletePesanan({ commit, state, getters, dispatch }, id) {
			try {
				await PesananService.deletePesanan(id);
			} catch (e) {

			}
		},
		calculateTotal({ commit, state, getters, dispatch }){
            let total = 0
            forEach(state.listPesanan, list =>{
                const subtotal = Number(list.harga_jual) * (1-(Number(list.discount) / 100)) * Number(list.qty)
                total += subtotal
			})
			commit('SET_LIST_PESANAN', state.listPesanan)
            commit('SET_TOTAL_HARGA_PESANAN', total)
        },
		resetPesanan({ commit, state, getters, dispatch }){
            commit('SET_LIST_PESANAN', [])
            commit('SET_TOTAL_HARGA_PESANAN', 0)
		},
		async detailOrder({ commit, state, getters, dispatch }){
			let paid = 0
			const response = await PesananService.getPesananById(state.idDialogOrder)
			// console.log('response', response)
			if(!isEmpty(response.data)){
				const responseUser = await UserService.getUserById(response.data[0].user_id)
				commit('SET_DATA_USER', responseUser.data.attributes)
				commit('SET_DATA_DETAILS', response.data[0])
				const responsePayment = await TransactionService.getTransactionBySubmissionId(state.idDialogOrder)
				isEmpty(responsePayment.data.attributes) ? commit('SET_PAYMENT_ITEMS', null) : commit('SET_PAYMENT_ITEMS', responsePayment.data.attributes)
				if(state.paymentItems != null){
					forEach(state.paymentItems, paymentItem => {
						paid += Number(paymentItem.jumlah)
					})
				}
			}
			commit('SET_PAID', paid)
		}
	},

	mutations: {
		SET_LIST_PESANAN(state, payload) {
			state.listPesanan = payload;
			window.localStorage.setItem('listPesanan', JSON.stringify(payload));
			window.localStorage.setItem('numberOfList', payload.length);
			state.numberOfList = payload.length;
		},
		SET_LIST_ORDER(state, payload) {
			state.listOrder = payload;
		},
		SET_TOTAL_HARGA_PESANAN(state, payload) {
			state.totalHargaPesanan = Number(payload);
		},
		SET_DIALOG_ORDER(state, payload) {
			state.dialogOrder = payload;
		},
		SET_DIALOG_LOGIN(state, payload) {
			state.dialogLogin = payload;
		},
		SET_DIALOG_REGIS(state, payload) {
			state.dialogRegis = payload;
		},
		SET_CUSTOMER(state, payload) {
			state.selectedCustomer = payload;
		},
		SET_USER_FOUND(state, payload) {
			state.userFound = payload;
		},
		SET_INPUT_SEARCH(state, payload) {
			state.inputSearch = payload;
		},
		SET_DIALOG_PAYMENT(state, payload) {
			state.dialogPayment = payload;
		},
		SET_ID_DIALOG_ORDER(state, payload) {
			state.idDialogOrder = Number(payload);
		},
		SET_DATA_USER(state, payload){
			state.dataUser = payload;
		},
		SET_DATA_DETAILS(state, payload){
			state.dataDetails = payload;
		},
		SET_PAYMENT_ITEMS(state, payload){
			state.paymentItems = payload;
		},
		SET_PAID(state, payload){
			state.paid = Number(payload);
		},
		SET_JUMLAH_PAYMENT(state, payload){
			state.jumlahPayment = Number(payload);
		}
	}
};
